import { useQuery } from 'react-query'
import { UserService } from 'auth'

export const useUsers = () => {
  return useQuery('users', UserService.getUsers)
}
